import { createApp, h } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { createInertiaApp, Head } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import BootstrapVue3 from 'bootstrap-vue-3'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Layout from './Shared/Layout.vue';
import moment from 'moment'
import 'moment/locale/es-mx';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
moment.locale('es');
//import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';


createInertiaApp({
  resolve: name => {
    // Loading default Layout
    let page = require(`./Pages/${name}`).default;

    if(! page.layout){
        page.layout = Layout;
    }

    page.layout ??= Layout;

    return page;
  },
  setup({ el, App, props, plugin }) {
    const captcheKey = props.initialPage.props.recaptcha_site_key;
    const app = createApp({ render: () => h(App, props) })
    .use(plugin)
    .use(BootstrapVue3)
    .use(VueReCaptcha, { siteKey: captcheKey, loaderOptions: {autoHideBadge: true} } )
    .use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyDpLez1oh5NA7ijKQA3QbBCxxLM7TR2_6M',
            language: 'es',
        },
    })
    .use(ZiggyVue, Ziggy)
    .component('font-awesome-icon', FontAwesomeIcon)
    .component("Head", Head)

    app.config.productionTip = false;

    // Globar Vars
    app.config.globalProperties.$telefono = "81 2285 0004";

    // Remove Warnings
    app.config.warnHandler = () => null;

    // Gobal Filters
    app.config.globalProperties.$filters = {
        truncate(text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
        getDayDate(date) {
            return moment(date).format("DD");
        },
        getMonthDate(date) {
            return moment(date).format("MMM").slice(0,-1);
        },
        getDayMonthDate(date) {
            return moment(date).format("DD [de] MMMM");
        },
        getShortDate(date) {
            return moment(date).format("DD MMM").slice(0,-1);
        },
        getFullDate(date) {
            return moment(date).format("DD [de] MMMM [de] YYYY");
        },
        getDate(date) {
            return moment(date).format("DD/MM/YYYY");
        },
        getMoneyFormat(number) {
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(number);
        },
    }

    app.mount(el)
  },
});

InertiaProgress.init();

if (process.env.NODE_ENV == "production") {
    Inertia.on("navigate", (event) => {
        window.gtag("js", new Date());
        window.gtag("config", "G-M29D65W2D0");
    });
}
